module.exports = __webpack_public_path__ + "img/pip_three_icon4.fb865c6b.png";